import React from 'react';
import styled from 'styled-components';
import { FaTools, FaCarAlt, FaClock, FaPhone, FaMapMarkerAlt, FaCalendarAlt, FaStar, FaUserCog, FaShieldAlt, FaOilCan } from 'react-icons/fa';
import DemoViewer from '../../components/DemoViewer';
import SEO from '../../components/SEO';

// Estilos para la demo de taller mecánico
const TallerDemo = styled.div`
  font-family: 'Roboto', sans-serif;
  color: #333;
`;

const HeroSection = styled.div`
  background-image: url('/servicios/tipo-cliente/taller-hero.webp');
  background-size: cover;
  background-position: center;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 800px;
  padding: 0 2rem;
`;

const TallerName = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #f39c12;
`;

const HeroTitle = styled.h1`
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
`;

const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

const BookButton = styled.button`
  background-color: #f39c12;
  color: white;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #e67e22;
    transform: translateY(-3px);
  }
`;

const Section = styled.section`
  padding: 5rem 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  
  &::after {
    content: '';
    width: 80px;
    height: 3px;
    background-color: #f39c12;
    position: absolute;
    bottom: -1rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const ServiceCard = styled.div`
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const ServiceIcon = styled.div`
  background-color: #f39c12;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    font-size: 3rem;
    color: white;
  }
`;

const ServiceContent = styled.div`
  padding: 1.5rem;
`;

const ServiceTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ServicePrice = styled.span`
  color: #f39c12;
  font-weight: bold;
`;

const ServiceDescription = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ServiceButton = styled.button`
  background-color: transparent;
  color: #f39c12;
  border: 1px solid #f39c12;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #f39c12;
    color: white;
  }
`;

const AboutSection = styled(Section)`
  background-color: #f9f9f9;
`;

const AboutContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const AboutImage = styled.div`
  flex: 1;
  min-width: 300px;
  height: 450px;
  background-image: url('/servicios/tipo-cliente/taller-about.webp');
  background-size: cover;
  background-position: center;
  border-radius: 8px;
`;

const AboutContent = styled.div`
  flex: 1;
  min-width: 300px;
`;

const AboutTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  position: relative;
  
  &::after {
    content: '';
    width: 80px;
    height: 3px;
    background-color: #f39c12;
    position: absolute;
    bottom: -1rem;
    left: 0;
  }
`;

const AboutText = styled.p`
  color: #666;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
`;

const FeatureSection = styled(Section)`
  background-color: #2c3e50;
  color: white;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
`;

const FeatureCard = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  color: #f39c12;
  margin-bottom: 1.5rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const FeatureText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
`;

const PricingSection = styled(Section)`
  background-color: #f9f9f9;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const PriceColumn = styled.div`
  flex: 1;
  min-width: 280px;
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
`;

const PriceColumnTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #333;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
`;

const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #eee;
  
  &:last-child {
    border-bottom: none;
  }
`;

const ServiceName = styled.span`
  color: #333;
`;

const Price = styled.span`
  color: #f39c12;
  font-weight: bold;
`;

const TestimonialsSection = styled(Section)`
  text-align: center;
`;

const TestimonialsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const TestimonialCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
  text-align: left;
`;

const TestimonialText = styled.p`
  font-style: italic;
  color: #666;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #eee;
  margin-right: 1rem;
  background-size: cover;
  background-position: center;
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.h4`
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
`;

const AuthorRating = styled.div`
  color: #f39c12;
  font-size: 0.9rem;
`;

const AuthorCar = styled.p`
  color: #666;
  font-size: 0.9rem;
  margin: 0;
`;

const ContactSection = styled(Section)`
  background-color: #2c3e50;
  color: white;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactCard = styled.div`
  padding: 2rem;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const ContactIcon = styled.div`
  font-size: 2.5rem;
  color: #f39c12;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const ContactTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const ContactText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-align: center;
`;

const Footer = styled.footer`
  background-color: #1a252f;
  color: white;
  padding: 2rem;
  text-align: center;
  
  p {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const TallerDemoPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Demo de Sitio Web para Talleres Mecánicos | Web a Bajo Coste"
        description="Visualiza cómo podría ser tu página web de taller mecánico con este ejemplo interactivo. Diseño optimizado para atraer clientes y mostrar tus servicios."
        keywords="demo web taller, diseño web taller mecánico, ejemplo web taller, página web taller"
        canonical="https://webabajocoste.es/plantillas/taller"
      >
        <meta name="robots" content="noindex, nofollow" />
      </SEO>
      
      <DemoViewer
        title="Demo Web para Talleres Mecánicos"
        subtitle="Visualiza cómo podría ser tu nueva web de taller, diseñada para atraer nuevos clientes y mostrar tus servicios de forma profesional"
        domainName="https://automecanica-express.es"
        serviceLink="/servicios/diseno-web-taller"
        serviceName="Talleres"
      >
        <TallerDemo>
          <HeroSection>
            <HeroContent>
              <TallerName>Automotriz Express</TallerName>
              <HeroTitle>Tu taller de confianza</HeroTitle>
              <HeroSubtitle>Servicio de calidad, atención personalizada y los mejores profesionales para el mantenimiento y reparación de tu vehículo.</HeroSubtitle>
              <BookButton>Solicitar Cita</BookButton>
            </HeroContent>
          </HeroSection>
          
          <Section>
            <Container>
              <SectionTitle>Nuestros Servicios</SectionTitle>
              
              <ServicesGrid>
                <ServiceCard>
                  <ServiceIcon>
                    <FaOilCan />
                  </ServiceIcon>
                  <ServiceContent>
                    <ServiceTitle>
                      Mantenimiento
                      <ServicePrice>Desde 60€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Revisiones periódicas, cambio de aceite y filtros, mantenimiento preventivo para mantener tu vehículo en óptimas condiciones.
                    </ServiceDescription>
                    <ServiceButton>Solicitar Cita</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceIcon>
                    <FaCarAlt />
                  </ServiceIcon>
                  <ServiceContent>
                    <ServiceTitle>
                      Mecánica General
                      <ServicePrice>Consultar</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Reparación de motores, sistemas de frenos, suspensión, dirección y transmisión. Diagnóstico electrónico avanzado.
                    </ServiceDescription>
                    <ServiceButton>Solicitar Cita</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceIcon>
                    <FaUserCog />
                  </ServiceIcon>
                  <ServiceContent>
                    <ServiceTitle>
                      Electricidad
                      <ServicePrice>Desde 45€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Diagnóstico y reparación de sistemas eléctricos y electrónicos, baterías, alternadores y sistemas de arranque.
                    </ServiceDescription>
                    <ServiceButton>Solicitar Cita</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceIcon>
                    <FaShieldAlt />
                  </ServiceIcon>
                  <ServiceContent>
                    <ServiceTitle>
                      Pre-ITV
                      <ServicePrice>40€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Revisión completa antes de la inspección técnica para garantizar que tu vehículo pase la ITV a la primera.
                    </ServiceDescription>
                    <ServiceButton>Solicitar Cita</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
              </ServicesGrid>
            </Container>
          </Section>
          
          <AboutSection>
            <AboutContainer>
              <AboutImage />
              
              <AboutContent>
                <AboutTitle>Sobre Nosotros</AboutTitle>
                <AboutText>
                  En Automotriz Express llevamos más de 20 años dedicados a la reparación y mantenimiento de vehículos. Nuestro taller nació con la visión de ofrecer servicios de alta calidad con total transparencia.
                </AboutText>
                <AboutText>
                  Contamos con un equipo de mecánicos certificados, en constante formación, que dominan las últimas tecnologías del sector automotriz. Utilizamos equipos de diagnóstico de última generación y recambios de primeras marcas.
                </AboutText>
                <AboutText>
                  Nuestra filosofía se basa en la honestidad, la calidad del servicio y el trato personalizado. No solo reparamos coches, creamos relaciones de confianza con nuestros clientes.
                </AboutText>
              </AboutContent>
            </AboutContainer>
          </AboutSection>
          
          <FeatureSection>
            <Container>
              <SectionTitle>¿Por qué elegirnos?</SectionTitle>
              
              <FeatureGrid>
                <FeatureCard>
                  <FeatureIcon>
                    <FaTools />
                  </FeatureIcon>
                  <FeatureTitle>Mecánicos Certificados</FeatureTitle>
                  <FeatureText>
                    Nuestro equipo cuenta con certificaciones oficiales y más de 20 años de experiencia combinada.
                  </FeatureText>
                </FeatureCard>
                
                <FeatureCard>
                  <FeatureIcon>
                    <FaShieldAlt />
                  </FeatureIcon>
                  <FeatureTitle>Garantía en Reparaciones</FeatureTitle>
                  <FeatureText>
                    Todas nuestras reparaciones incluyen garantía de 12 meses en piezas y mano de obra.
                  </FeatureText>
                </FeatureCard>
                
                <FeatureCard>
                  <FeatureIcon>
                    <FaClock />
                  </FeatureIcon>
                  <FeatureTitle>Servicio Rápido</FeatureTitle>
                  <FeatureText>
                    Nos comprometemos a cumplir los plazos de entrega acordados para que puedas seguir con tu rutina.
                  </FeatureText>
                </FeatureCard>
                
                <FeatureCard>
                  <FeatureIcon>
                    <FaCarAlt />
                  </FeatureIcon>
                  <FeatureTitle>Vehículo de Sustitución</FeatureTitle>
                  <FeatureText>
                    Disponemos de vehículos de cortesía para que puedas seguir con tu día a día mientras reparamos tu coche.
                  </FeatureText>
                </FeatureCard>
              </FeatureGrid>
            </Container>
          </FeatureSection>
          
          <PricingSection>
            <Container>
              <SectionTitle>Tarifas de Servicios</SectionTitle>
              
              <PriceContainer>
                <PriceColumn>
                  <PriceColumnTitle>Mantenimiento</PriceColumnTitle>
                  
                  <PriceItem>
                    <ServiceName>Revisión Básica</ServiceName>
                    <Price>45€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Aceite + Filtro</ServiceName>
                    <Price>60€ - 90€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Filtros (aire, combustible)</ServiceName>
                    <Price>30€ - 50€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Correa Distribución</ServiceName>
                    <Price>350€ - 500€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Líquido de Frenos</ServiceName>
                    <Price>40€</Price>
                  </PriceItem>
                </PriceColumn>
                
                <PriceColumn>
                  <PriceColumnTitle>Reparaciones</PriceColumnTitle>
                  
                  <PriceItem>
                    <ServiceName>Diagnóstico Electrónico</ServiceName>
                    <Price>30€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Pastillas de Freno</ServiceName>
                    <Price>80€ - 120€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Amortiguadores (par)</ServiceName>
                    <Price>180€ - 250€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Cambio Embrague</ServiceName>
                    <Price>450€ - 700€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Carga Aire Acondicionado</ServiceName>
                    <Price>60€</Price>
                  </PriceItem>
                </PriceColumn>
              </PriceContainer>
            </Container>
          </PricingSection>
          
          <TestimonialsSection>
            <Container>
              <SectionTitle>Lo que dicen nuestros clientes</SectionTitle>
              
              <TestimonialsContainer>
                <TestimonialCard>
                  <TestimonialText>
                    "Llevo más de 5 años llevando mi coche a Automotriz Express y nunca me han fallado. Son transparentes con los precios, explican todo el proceso y las reparaciones son de calidad. Me solucionaron un problema con el sistema eléctrico que otros talleres no pudieron diagnosticar."
                  </TestimonialText>
                  <TestimonialAuthor>
                    <AuthorAvatar style={{ backgroundImage: 'url("/servicios/tipo-cliente/cliente-taller1.webp")' }} />
                    <AuthorInfo>
                      <AuthorName>Carlos Rodríguez</AuthorName>
                      <AuthorCar>Volkswagen Golf TDI</AuthorCar>
                      <AuthorRating>
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </AuthorRating>
                    </AuthorInfo>
                  </TestimonialAuthor>
                </TestimonialCard>
                
                <TestimonialCard>
                  <TestimonialText>
                    "Fui por una revisión y descubrieron un problema en los frenos que podría haber sido peligroso. Lo repararon en el mismo día y a un precio justo. Además, me explicaron cómo evitar el problema en el futuro. Trato excelente y muy profesionales."
                  </TestimonialText>
                  <TestimonialAuthor>
                    <AuthorAvatar style={{ backgroundImage: 'url("/servicios/tipo-cliente/cliente-taller2.webp")' }} />
                    <AuthorInfo>
                      <AuthorName>Laura Martínez</AuthorName>
                      <AuthorCar>Renault Clio</AuthorCar>
                      <AuthorRating>
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </AuthorRating>
                    </AuthorInfo>
                  </TestimonialAuthor>
                </TestimonialCard>
              </TestimonialsContainer>
            </Container>
          </TestimonialsSection>
          
          <ContactSection>
            <Container>
              <SectionTitle>Contacto</SectionTitle>
              
              <ContactGrid>
                <ContactCard>
                  <ContactIcon>
                    <FaMapMarkerAlt />
                  </ContactIcon>
                  <ContactTitle>Ubicación</ContactTitle>
                  <ContactText>
                    Polígono Industrial Las Acacias, Nave 23<br />
                    28923 Alcorcón, Madrid
                  </ContactText>
                </ContactCard>
                
                <ContactCard>
                  <ContactIcon>
                    <FaClock />
                  </ContactIcon>
                  <ContactTitle>Horario</ContactTitle>
                  <ContactText>
                    Lunes a Viernes: 9:00 - 19:00<br />
                    Sábados: 9:00 - 14:00
                  </ContactText>
                </ContactCard>
                
                <ContactCard>
                  <ContactIcon>
                    <FaPhone />
                  </ContactIcon>
                  <ContactTitle>Teléfono</ContactTitle>
                  <ContactText>
                    916 123 456<br />
                    WhatsApp: 600 123 456
                  </ContactText>
                </ContactCard>
              </ContactGrid>
            </Container>
          </ContactSection>
          
          <Footer>
            <p>© 2023 Automotriz Express | Todos los derechos reservados</p>
          </Footer>
        </TallerDemo>
      </DemoViewer>
    </>
  );
};

export default TallerDemoPage; 